import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import PeriodChip from "../chips/PeriodChip";
import ProgressBar from "../progress/ProgressBar";
import { t } from "i18next";

const useInitiativeCardStyles = makeThemedStyles("InitiativeCard", (theme) => ({
  root: {
    padding: "20px",
    width: "320px",
    minHeight: "330px",
    borderRadius: "4px",
    background:
      "linear-gradient(0deg, #E1F5FF 0%, rgba(225, 245, 255, 0) 100%)",
    color: "rgba(16, 41, 118, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "12px",
  },
  actualTargetContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "20px",
    marginTop: "20px",
    marginBottom: "20px",
  },
  actualTarget: {
    color: "#555",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    fontSize: "14px",
    gap: "5px",
    "& div:nth-child(1)": {
      fontWeight: "bold",
      textAlign: "center",
    },
  },
  title: {
    color: "rgba(101, 106, 114, 1)",
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "20px",
  },
  subTitle: {
    color: "rgba(16, 41, 118, 1)",
    fontWeight: "bold",
    fontSize: "14px",
  },
  titleTypeName: {
    color: "rgba(16, 41, 118, 1)",
  },
  chartTitleStyle: {
    fontFamily: "Roboto, Helvetica",
    fontSize: "12px",
  },
}));

export const InitiativeCardTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useInitiativeCardStyles();
  return <div className={styles.title}>{props.children}</div>;
};

export const InitiativeCardTypeName = (props: React.PropsWithChildren<{}>) => {
  const styles = useInitiativeCardStyles();
  return <div className={styles.titleTypeName}>{props.children}</div>;
};

export const InitiativeCard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      translatedName: string;
      period: string;
      cardTitle: string;
      valueFrom?: keyof ICardElementWithChildren;
      valuePrettyValue?: keyof ICardElementWithChildren;
      left_number_title: string;
      left_number_key: keyof ICardElementWithChildren;
      right_number_title: string;
      right_number_key: keyof ICardElementWithChildren;
      onSelect?: () => void;
      width?: string;
      height?: string;
    }>
  ) => {
    const styles = useInitiativeCardStyles();
    const { element: el } = props;
    return (
      <div
        className={styles.root}
        role="button"
        style={{
          cursor: props.onSelect ? "pointer" : undefined,
          width: props.width,
          minHeight: props.height,
        }}
        tabIndex={0}
        onKeyDown={() => {}}
        onClick={() => {
          if (props.onSelect) {
            props.onSelect();
          }
        }}
      >
        <PeriodChip
          title={t("configtypes." + el.typename)}
          period={el.periodname || ""}
          icon="Initiative"
        />

        <div className={styles.title}>{props.cardTitle}</div>

        <ProgressBar
          title={String(
            el[props.valuePrettyValue || "COMPLETION_PERCENTAGE_prettyvalue"]
          )}
          value={Number(el[props.valueFrom || "COMPLETION_PERCENTAGE"] || 0)}
          barColor={`#${el.rangecolor || "777777"}`}
        />

        <div className={styles.actualTargetContainer}>
          <div className={styles.actualTarget}>
            <div>{el[props.left_number_key] || "-"}</div>
            <div>{props.left_number_title}</div>
          </div>
          <div className={styles.actualTarget}>
            <div>{el[props.right_number_key] || "-"}</div>
            <div>{props.right_number_title}</div>
          </div>
        </div>

        <div className={styles.subTitle}>{props.translatedName}</div>
      </div>
    );
  }
);
